import { render, staticRenderFns } from "./AttachmentWasDeleted.vue?vue&type=template&id=639148d8"
import script from "./AttachmentWasDeleted.vue?vue&type=script&lang=js"
export * from "./AttachmentWasDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports